import { render } from "./TradeSwapView.vue?vue&type=template&id=b53057f6"
import script from "./TradeSwapView.vue?vue&type=script&lang=js"
export * from "./TradeSwapView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__